import { render, staticRenderFns } from "./SingleTeaserBlock.vue?vue&type=template&id=f4ce4cd6"
import script from "./SingleTeaserBlock.vue?vue&type=script&lang=js"
export * from "./SingleTeaserBlock.vue?vue&type=script&lang=js"
import style0 from "./SingleTeaserBlock.vue?vue&type=style&index=0&id=f4ce4cd6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports